import { cloneDeep as h, defaults as A } from "lodash-es";
import { format as O } from "date-fns";
const M = {
  reloading: !1,
  loaded: !1,
  errored: !1,
  errorType: null,
  errorData: null,
  options: {},
  preselectedFilters: [],
  search: {
    query: "",
    filters: [],
    page: 0,
    sortOption: null,
    extended: {}
  },
  results: {},
  previousItemResults: []
}, N = {
  loaded: ({ loaded: e }) => e,
  errored: ({ errored: e }) => e,
  errorType: ({ errorType: e }) => e,
  errorData: ({ errorData: e }) => e,
  reloading: ({ reloading: e }) => e,
  results: ({ results: e }) => e,
  query: ({ search: e }) => e.query,
  sort: ({ search: e }) => e.sortOption,
  filters: ({ search: e }) => e.filters,
  currentPage: ({ search: e }) => e.page,
  extended: ({ search: e }) => e.extended
}, j = {
  setLoaded(e) {
    e.loaded = !0, e.reloading = !1;
  },
  setReloading(e) {
    e.reloading = !0;
  },
  setErrored(e, { type: t, data: r }) {
    e.errored = !0, e.errorType = t, e.errorData = r;
  },
  clearError(e) {
    e.errored = !1, e.errorType = null, e.errorData = null;
  },
  updateQueryParams(e) {
    const t = new URL(window.location.href), r = new URLSearchParams(t.search);
    Object.entries(e.search).forEach(([a, o]) => {
      a !== "extended" && (Array.isArray(o) ? o = V(o) : typeof o == "object" ? o = !1 : typeof o == "string" && (o = o.trim()), a === "page" ? e.options.preserveResults ? r.delete(a) : o ? r.set(e.options.queryStringKeyPage, o + 1) : r.delete(e.options.queryStringKeyPage) : a === "query" ? o ? r.set(e.options.queryStringKeyQuery, o) : r.delete(e.options.queryStringKeyQuery) : a === "filters" ? o ? r.set(e.options.queryStringKeyFilters, o) : r.delete(e.options.queryStringKeyFilters) : o ? r.set(a, o) : r.delete(a));
    });
    const s = !r.keys().next().done, i = `${t.pathname}${s ? `?${r.toString()}` : ""}`, n = e.options.paginationUsesHistory ? { page: e.search.page } : {};
    history.replaceState(n, "", decodeURIComponent(i));
  },
  applyOptions(e, t) {
    e.options = t;
  },
  parseInitialQueryParams(e) {
    const t = new URL(window.location.href);
    new URLSearchParams(t.search).forEach((s, i) => {
      if (s)
        if (i === e.options.queryStringKeyFilters)
          e.preselectedFilters = s.split(",");
        else if (i === e.options.queryStringKeyPage) {
          if (!e.options.preserveResults && !isNaN(s)) {
            let n = Number(s);
            n > 0 && n--, e.search.page = n;
          }
        } else
          i === e.options.queryStringKeyQuery && (e.search.query = s);
      else
        return;
    });
  },
  setResults(e, t) {
    e.options.preserveResults && (e.previousItemResults.push(...t.itemResults), t.itemResults = e.previousItemResults), e.results = t, e.search.filters = h(t.filters), e.search.query = t.queryUsed.searchTerm, e.search.sortOption = t.queryUsed.sortOption, e.search.page = t.queryUsed.currentPage, e.search.extended = t.extended ? h(t.extended) : t.queryUsed.extended, e.preselectedFilters = [];
  },
  setQuery(e, t) {
    e.search.query = t, e.search.page = 0;
  },
  resetAllFilters(e) {
    const t = e.search.filters;
    e.search.page = 0;
    const r = (s) => s.forEach((i) => {
      i.selected = !1, i.filters && i.filters.length && r(i.filters);
    });
    t.forEach((s) => r(s.filters));
  },
  setFilterValue(e, { filter: t, value: r }) {
    const s = e.search.filters;
    e.search.page = 0;
    const i = (n) => n.some((a) => a.id === t.id ? (a.selected = r, !0) : a.filters && a.filters.length ? i(a.filters) : !1);
    s.some((n) => i(n.filters));
  },
  setPageIndex(e, t) {
    e.search.page = t;
  },
  setSortOrder(e, t) {
    e.search.sortOption = t, e.search.page = 0;
  },
  clearPreviousItemResults(e) {
    e.previousItemResults = [];
  },
  extend(e, t) {
    e.search.extended = h(t(e.search.extended));
  },
  clearSearchParameters(e) {
    e.loaded = !1, e.preselectedFilters = [], e.search.query = "", e.search.filters = [], e.search.page = 0, e.search.sortOption = null, e.search.extended = {}, e.results = {}, e.previousItemResults = [];
  },
  checkForConfigErrors(e) {
    e.options.queryRequired && (e.search.query.trim().length < 1 ? this.commit("setErrored", { type: "queryRequired", data: null }) : this.commit("clearError"));
  }
}, k = {
  changeSort({ commit: e, dispatch: t }, r) {
    return e("setSortOrder", r), e("clearPreviousItemResults"), t("executeSearch");
  },
  goToPage({ commit: e, dispatch: t }, r) {
    return e("setPageIndex", r), t("executeSearch");
  },
  removeAllTags({ commit: e, dispatch: t }) {
    return e("resetAllFilters"), e("clearPreviousItemResults"), t("executeSearch");
  },
  removeTagItem({ commit: e, dispatch: t }, r) {
    return e("setFilterValue", { filter: r, value: !1 }), e("clearPreviousItemResults"), t("executeSearch");
  },
  resetSearch({ commit: e, dispatch: t }, r = (s) => s) {
    e("clearSearchParameters"), t("executeSearch", r);
  },
  executeSearch({ commit: e, state: t }, r = (s) => s) {
    return new Promise(async (s) => {
      if (e("checkForConfigErrors"), t.errored)
        return s();
      const i = new Date().getTime();
      e("setReloading");
      let n, a = {
        searchIndex: t.options.searchIndex,
        searchTerm: t.search.query,
        filters: t.search.filters,
        currentPage: t.search.page,
        pageSize: t.options.pageLength,
        preselectedFilters: t.preselectedFilters,
        extended: t.search.extended,
        ...t.search.sortOption && {
          sortOption: t.search.sortOption
        }
      };
      a.searchTerm = String(a.searchTerm), r && typeof r == "function" && (n = r(a)), n && (a = h(n)), a = JSON.stringify(a);
      const o = await fetch(t.options.endpoint, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        },
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: a
      });
      if (o.ok) {
        const l = await o.json();
        e("setResults", l), e("updateQueryParams");
        const c = new Date().getTime() - i, _ = c < 750 ? 750 - c : 0;
        setTimeout(() => {
          e("setLoaded"), s();
        }, _);
      } else {
        const l = await o.json();
        e("setErrored", { type: "severError", data: l }), s();
      }
    });
  }
}, yt = {
  state: M,
  getters: N,
  mutations: j,
  actions: k
};
function V(e) {
  const t = [], r = (s) => s.reduce((i, n) => {
    if (n.selected == !0 && i.push(n.id), n.filters && n.filters.length) {
      let a = r(n.filters);
      a.length && i.push(...a);
    }
    return i;
  }, []);
  return e.forEach((s) => {
    let i = r(s.filters);
    i.length && t.push(...i);
  }), t.join(",");
}
var Q = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("transition", {
    attrs: {
      name: "navigate",
      appear: "",
      mode: "out-in"
    }
  }, [e._t("default")], 2);
}, L = [];
function u(e, t, r, s, i, n, a, o) {
  var l = typeof e == "function" ? e.options : e;
  t && (l.render = t, l.staticRenderFns = r, l._compiled = !0), s && (l.functional = !0), n && (l._scopeId = "data-v-" + n);
  var c;
  if (a ? (c = function(d) {
    d = d || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !d && typeof __VUE_SSR_CONTEXT__ < "u" && (d = __VUE_SSR_CONTEXT__), i && i.call(this, d), d && d._registeredComponents && d._registeredComponents.add(a);
  }, l._ssrRegister = c) : i && (c = o ? function() {
    i.call(
      this,
      (l.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), c)
    if (l.functional) {
      l._injectStyles = c;
      var _ = l.render;
      l.render = function(D, p) {
        return c.call(p), _(D, p);
      };
    } else {
      var f = l.beforeCreate;
      l.beforeCreate = f ? [].concat(f, c) : [c];
    }
  return {
    exports: e,
    options: l
  };
}
const B = {
  name: "transition-navigate"
}, g = {};
var U = /* @__PURE__ */ u(
  B,
  Q,
  L,
  !1,
  W,
  null,
  null,
  null
);
function W(e) {
  for (let t in g)
    this[t] = g[t];
}
const F = /* @__PURE__ */ function() {
  return U.exports;
}();
var z = function() {
  var e = this, t = e.$createElement;
  return e._self._c, e._m(0);
}, K = [function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("div", {
    staticClass: "loader"
  }, [r("div"), r("div"), r("div"), r("div"), r("div"), r("div"), r("div"), r("div")]);
}];
const H = {
  name: "loader"
}, m = {};
var G = /* @__PURE__ */ u(
  H,
  z,
  K,
  !1,
  X,
  "150b3507",
  null,
  null
);
function X(e) {
  for (let t in m)
    this[t] = m[t];
}
const q = /* @__PURE__ */ function() {
  return G.exports;
}();
var J = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("div", {
    staticClass: "search",
    attrs: {
      id: "bluesearch"
    }
  }, [r("TransitionNavigate", [e.loaded ? [e._t("default", function() {
    return [r("div", {
      staticClass: "search__layout",
      attrs: {
        "data-hide-rail": e.options.hideRail
      }
    }, [e._t("header", function() {
      return [e.options.showQuery ? r("header", {
        staticClass: "search__header"
      }, [r("SearchQuery")], 1) : e._e()];
    }), e.options.hideRail ? e._e() : e._t("rail", function() {
      return [e.options.showFilters ? r("aside", {
        staticClass: "search__rail"
      }, [r("SearchFilters")], 1) : e._e()];
    }), e._t("main", function() {
      return [r("section", {
        staticClass: "search__main"
      }, [e._t("tags", function() {
        return [r("SearchTags")];
      }), e._t("results", function() {
        return [r("SearchResults")];
      })], 2)];
    }), e._t("footer", function() {
      return [r("footer", {
        staticClass: "search__footer"
      }, [r("SearchPagination")], 1)];
    })], 2)];
  }, {
    loaded: e.loaded,
    reloading: e.reloading,
    executeSearch: e.executeSearch,
    results: e.results,
    extend: e.extend,
    extended: e.extended
  })] : e.errored ? [e._t("error", function() {
    return [r("p", [e._v("There was an error")])];
  }, {
    errored: e.errored,
    errorType: e.errorType,
    errorData: e.errorData
  })] : [e._t("loader", function() {
    return [r("SearchLoader")];
  }, {
    loaded: e.loaded
  })]], 2)], 1);
}, Z = [];
const Y = {
  name: "BlueSearch",
  components: { TransitionNavigate: F, SearchLoader: q },
  data() {
    return {
      preSearch: null
    };
  },
  computed: {
    reloading() {
      return this.$store.getters.reloading;
    },
    loaded() {
      return this.$store.getters.loaded && !this.$store.getters.errored;
    },
    errored() {
      return this.$store.getters.errored;
    },
    errorType() {
      return this.$store.getters.errorType;
    },
    errorData() {
      return this.$store.getters.errorData;
    },
    results() {
      return this.$store.getters.results;
    },
    extended() {
      return this.$store.getters.extended;
    }
  },
  methods: {
    executeSearch(e) {
      return this.$store.dispatch("executeSearch", e);
    },
    extend(e) {
      this.$store.commit("extend", e);
    }
  },
  created() {
    this.$store.commit("applyOptions", this.options), this.$store.commit("parseInitialQueryParams"), this.options.allowPreSearch && (this.preSearch = new Promise((e) => {
      let t = !1;
      const r = () => {
        t = !0, e();
      };
      this.$emit("presearch", {
        done: r,
        extend: this.extend,
        extended: this.extended
      }), setTimeout(() => {
        t || r();
      }, 1500);
    }));
  },
  async mounted() {
    this.options.allowPreSearch && await this.preSearch, this.$store.dispatch("executeSearch");
  }
}, v = {};
var ee = /* @__PURE__ */ u(
  Y,
  J,
  Z,
  !1,
  te,
  "bab69de4",
  null,
  null
);
function te(e) {
  for (let t in v)
    this[t] = v[t];
}
const re = /* @__PURE__ */ function() {
  return ee.exports;
}();
var se = /\{([0-9a-zA-Z_]+)\}/g, ie = ne;
function ne(e) {
  var t;
  if (arguments.length === 2 && typeof arguments[1] == "object")
    t = arguments[1];
  else {
    t = new Array(arguments.length - 1);
    for (var r = 1; r < arguments.length; ++r)
      t[r - 1] = arguments[r];
  }
  return (!t || !t.hasOwnProperty) && (t = {}), e.replace(se, function(i, n, a) {
    var o;
    return e[a - 1] === "{" && e[a + i.length] === "}" ? n : (o = t.hasOwnProperty(n) ? t[n] : null, o == null ? "" : o);
  });
}
var ae = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("span", {
    staticClass: "root"
  }, [e._t("default", function() {
    return [r("div", {
      staticClass: "search-query"
    }, [r("form", {
      staticClass: "search-query__form",
      on: {
        submit: function(s) {
          return s.preventDefault(), s.stopPropagation(), function() {
            return !1;
          }.apply(null, arguments);
        }
      }
    }, [r("div", {
      staticClass: "search-query__wrapper"
    }, [r("label", {
      staticClass: "search-query__label",
      attrs: {
        for: "search-query__input"
      }
    }, [e._v(e._s(e.options.queryPlaceholderText))]), r("input", {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: e.queryModel,
        expression: "queryModel"
      }],
      staticClass: "search-query__input",
      attrs: {
        id: "search-query__input",
        placeholder: e.options.queryPlaceholderText,
        autocomplete: e.autocomplete,
        type: "text",
        name: "search-query"
      },
      domProps: {
        value: e.queryModel
      },
      on: {
        keypress: function(s) {
          return !s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter") ? null : (s.preventDefault(), e.executeSearch());
        },
        input: function(s) {
          s.target.composing || (e.queryModel = s.target.value);
        }
      }
    }), e.options.showReset ? r("button", {
      staticClass: "search-query__reset",
      attrs: {
        type: "button"
      },
      on: {
        click: function(s) {
          return e.resetSearch();
        }
      }
    }, [r("span", [e._v(e._s(e.options.resetText))])]) : e._e()]), r("button", {
      staticClass: "search-query__submit",
      attrs: {
        type: "submit"
      },
      on: {
        click: function(s) {
          return s.preventDefault(), s.stopPropagation(), e.executeSearch();
        }
      }
    }, [r("span", [e._v(e._s(e.options.querySubmitText))])]), e.options.showSort ? r("div", {
      staticClass: "search-query__sort"
    }, [r("label", {
      staticClass: "search-query__sort-label",
      attrs: {
        for: "search-query__sort-select"
      }
    }, [e._v("Sort results")]), r("select", {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: e.sortModel,
        expression: "sortModel"
      }],
      attrs: {
        id: "search-query__sort-select"
      },
      on: {
        change: function(s) {
          var i = Array.prototype.filter.call(s.target.options, function(n) {
            return n.selected;
          }).map(function(n) {
            var a = "_value" in n ? n._value : n.value;
            return a;
          });
          e.sortModel = s.target.multiple ? i : i[0];
        }
      }
    }, e._l(e.results.sortOptions, function(s) {
      return r("option", {
        domProps: {
          value: s
        }
      }, [e._v(e._s(e.options.sortText) + " " + e._s(s.displayName))]);
    }), 0)]) : e._e()]), r("small", {
      staticClass: "search-query__results"
    }, [e._v(e._s(e.label))])])];
  }, {
    results: e.results,
    query: e.query,
    setQuery: e.setQuery,
    sort: e.sort,
    setSort: e.setSort,
    resetSearch: e.resetSearch,
    currentResultsStart: e.currentResultsStart,
    currentResultsEnd: e.currentResultsEnd,
    clearPreviousItemResults: e.clearPreviousItemResults,
    executeSearch: e.executeSearch,
    extend: e.extend,
    extended: e.extended
  })], 2);
}, oe = [];
const le = {
  name: "BlueQuery",
  components: {},
  data() {
    return {};
  },
  computed: {
    autocomplete() {
      const e = this.options.queryAllowAutocomplete;
      return e === !0 ? "on" : e === !1 ? "off" : typeof e == "string" && e.trim().length ? e.trim() : !1;
    },
    currentResultsStart() {
      let e = this.results.totalResultCount;
      return this.results.currentPage == 0 || this.options.preserveResults ? e ? 1 : 0 : this.results.currentPage * this.results.pageSize + 1;
    },
    currentResultsEnd() {
      let e = this.results.totalResultCount, t = this.results.currentPage, r = this.results.pageSize, s = (t + 1) * r;
      return t == 0 ? e <= r ? e : r : s > e ? e : s;
    },
    label() {
      return ie(this.options.resultsLabelTemplate, {
        start: this.currentResultsStart,
        end: this.currentResultsEnd,
        total: this.results.totalResultCount
      });
    },
    results() {
      return this.$store.getters.results;
    },
    sort() {
      return this.$store.getters.sort;
    },
    sortModel: {
      get() {
        return this.sort;
      },
      set(e) {
        this.setSort(e);
      }
    },
    query() {
      return this.$store.getters.query;
    },
    queryModel: {
      get() {
        return this.query;
      },
      set(e) {
        this.setQuery(e);
      }
    },
    extended() {
      return this.$store.getters.extended;
    }
  },
  methods: {
    clearPreviousItemResults() {
      this.$store.commit("clearPreviousItemResults"), this.$store.commit("setPageIndex", 0);
    },
    setSort(e) {
      let t;
      typeof e == "object" && e.hasOwnProperty("target") ? t = e.target.value : t = e, this.$store.dispatch("changeSort", t);
    },
    setQuery(e) {
      let t;
      typeof e == "object" ? t = e.target.value : t = e, this.$store.commit("setQuery", t);
    },
    resetSearch(e) {
      this.$store.dispatch("resetSearch", e);
    },
    extend(e) {
      this.$store.commit("extend", e);
    },
    executeSearch(e) {
      return this.options.preserveResults && this.$store.commit("clearPreviousItemResults"), this.$store.dispatch("executeSearch", e);
    }
  },
  created() {
  },
  mounted() {
  }
}, y = {};
var ue = /* @__PURE__ */ u(
  le,
  ae,
  oe,
  !1,
  ce,
  "38c8d6f1",
  null,
  null
);
function ce(e) {
  for (let t in y)
    this[t] = y[t];
}
const de = /* @__PURE__ */ function() {
  return ue.exports;
}();
var he = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("transition-group", {
    attrs: {
      name: "expand"
    },
    on: {
      enter: e.enter,
      "after-enter": e.afterEnter,
      leave: e.leave
    }
  }, [e._t("default")], 2);
}, _e = [];
const fe = {
  name: "transition-expand",
  methods: {
    enter(e) {
      const t = getComputedStyle(e).width;
      e.style.width = t, e.style.position = "absolute", e.style.visibility = "hidden", e.style.height = "auto";
      const r = getComputedStyle(e).height;
      e.style.width = null, e.style.position = null, e.style.visibility = null, e.style.height = 0, getComputedStyle(e).height, requestAnimationFrame(() => {
        e.style.height = r;
      });
    },
    afterEnter(e) {
      e.style.height = "auto";
    },
    leave(e) {
      const t = getComputedStyle(e).height;
      e.style.height = t, getComputedStyle(e).height, requestAnimationFrame(() => {
        e.style.height = 0;
      });
    }
  }
}, x = {};
var pe = /* @__PURE__ */ u(
  fe,
  he,
  _e,
  !1,
  ge,
  "9192ea82",
  null,
  null
);
function ge(e) {
  for (let t in x)
    this[t] = x[t];
}
const I = /* @__PURE__ */ function() {
  return pe.exports;
}();
var me = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("div", {
    staticClass: "search-filters-group"
  }, [r("div", {
    staticClass: "search-filters-group__title",
    class: {
      active: e.active
    },
    attrs: {
      role: "button",
      tabindex: "0"
    },
    on: {
      click: function(s) {
        s.stopPropagation(), s.preventDefault(), e.active = !e.active;
      },
      keyup: function(s) {
        if (!s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter"))
          return null;
        s.stopPropagation(), s.preventDefault(), e.active = !e.active;
      }
    }
  }, [e._v(e._s(e.group.name))]), r("TransitionExpand", [e.active ? r("div", {
    key: "filterGroup",
    staticClass: "search-filters-group__options"
  }, [r("div", {
    staticClass: "search-filters-group__options-inner"
  }, [e._t("default")], 2)]) : e._e()])], 1);
}, ve = [];
const ye = {
  name: "BlueFilterGroup",
  components: { TransitionExpand: I },
  props: ["group", "initiallyExpanded"],
  data() {
    return {
      active: this.initiallyExpanded
    };
  },
  created() {
    const e = (t) => {
      let r = !1;
      return t.forEach((s) => {
        (s.selected || s.filters && s.filters.length && e(s.filters)) && (r = !0);
      }), r;
    };
    e(this.group.filters) && (this.active = !0);
  }
}, b = {};
var xe = /* @__PURE__ */ u(
  ye,
  me,
  ve,
  !1,
  be,
  "5ef4e97d",
  null,
  null
);
function be(e) {
  for (let t in b)
    this[t] = b[t];
}
const $e = /* @__PURE__ */ function() {
  return xe.exports;
}();
var Se = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return e.filter.count > 0 || e.model ? r("div", {
    staticClass: "search-filters-item"
  }, [r("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: e.model,
      expression: "model"
    }],
    staticClass: "search-filters-item__input",
    attrs: {
      type: "checkbox",
      id: e.filter.id,
      disabled: e.disabled
    },
    domProps: {
      checked: Array.isArray(e.model) ? e._i(e.model, null) > -1 : e.model
    },
    on: {
      change: function(s) {
        var i = e.model, n = s.target, a = !!n.checked;
        if (Array.isArray(i)) {
          var o = null, l = e._i(i, o);
          n.checked ? l < 0 && (e.model = i.concat([o])) : l > -1 && (e.model = i.slice(0, l).concat(i.slice(l + 1)));
        } else
          e.model = a;
      }
    }
  }), r("label", {
    staticClass: "search-filters-item__label",
    attrs: {
      for: e.filter.id
    }
  }, [r("span", [e._v(e._s(e.label))])]), e.hasChildren ? r("button", {
    staticClass: "search-filters-item__expand",
    class: {
      active: e.active
    },
    attrs: {
      type: "button"
    },
    on: {
      click: function(s) {
        s.stopPropagation(), s.preventDefault(), e.active = !e.active;
      },
      keydown: function(s) {
        if (!s.type.indexOf("key") && e._k(s.keyCode, "enter", 13, s.key, "Enter"))
          return null;
        s.stopPropagation(), s.preventDefault(), e.active = !e.active;
      }
    }
  }) : e._e(), e.hasChildren ? r("TransitionExpand", [e.active ? r("div", {
    key: `${e.label}-subFilters`,
    staticClass: "search-filters-item__filters"
  }, [r("div", {
    staticClass: "search-filters-item__filters-inner"
  }, e._l(e.filter.filters, function(s) {
    return r("BlueFilterItem", {
      key: s.id,
      attrs: {
        filter: s,
        setFilterValue: e.setFilterValue,
        disable: e.disableChildren
      }
    });
  }), 1)]) : e._e()]) : e._e()], 1) : e._e();
}, Pe = [];
const we = {
  name: "BlueFilterItem",
  components: { TransitionExpand: I },
  props: ["filter", "setFilterValue", "disable"],
  data() {
    return {
      active: !1
    };
  },
  computed: {
    disableChildren() {
      return !!(this.options.filterParentsExcludeChildren && (this.hasChildren && this.model || this.disable));
    },
    disabled() {
      return this.disable || !1;
    },
    hasChildren() {
      return !!(this.filter.filters && this.filter.filters.length);
    },
    label() {
      return this.options.showFiltersCount ? `${this.filter.value} (${this.filter.count})` : this.filter.value;
    },
    reloading() {
      return this.$store.getters.reloading;
    },
    model: {
      get() {
        return this.filter.selected;
      },
      set(e) {
        if (this.setFilterValue(this.filter, e), this.options.filterParentsExcludeChildren && e && this.hasChildren) {
          const t = (r) => {
            this.setFilterValue(r, !1), r.filters && r.filters.length && r.filters.forEach(t);
          };
          this.filter.filters.forEach(t);
        }
      }
    }
  },
  methods: {
    parseTreeActiveState(e) {
      let t = !1;
      return e.forEach((r) => {
        (r.selected || r.filters && r.filters.length && this.parseTreeActiveState(r.filters)) && (t = !0);
      }), t;
    }
  },
  watch: {
    reloading() {
      this.hasChildren && (this.active = this.parseTreeActiveState(this.filter.filters));
    }
  },
  created() {
    this.hasChildren && this.parseTreeActiveState(this.filter.filters) && (this.active = !0);
  }
}, $ = {};
var Te = /* @__PURE__ */ u(
  we,
  Se,
  Pe,
  !1,
  Ce,
  "4440e2ad",
  null,
  null
);
function Ce(e) {
  for (let t in $)
    this[t] = $[t];
}
const Re = /* @__PURE__ */ function() {
  return Te.exports;
}();
var Ee = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("span", {
    staticClass: "root"
  }, [e._t("default", function() {
    return [r("div", {
      staticClass: "search-filters"
    }, [e._t("mobileDrawerToggle", function() {
      return [r("button", {
        staticClass: "search-filters__toggle",
        attrs: {
          disabled: e.filters.length ? !1 : "disabled",
          tabindex: e.filters.length ? !1 : "-1"
        },
        on: {
          click: e.toggleMobileDrawer
        }
      }, [e._v(e._s(e.options.filterDrawerToggleText))])];
    }, {
      toggleMobileDrawer: e.toggleMobileDrawer,
      mobileDrawerOpen: e.mobileDrawerOpen
    }), r("div", {
      staticClass: "search-filters__inner",
      class: {
        active: e.mobileDrawerOpen
      },
      on: {
        click: function(s) {
          return s.target !== s.currentTarget ? null : e.toggleMobileDrawer(!1);
        }
      }
    }, [e._t("mobileDrawerClose", function() {
      return [r("button", {
        staticClass: "search-filters__close",
        on: {
          click: function(s) {
            return e.toggleMobileDrawer(!1);
          }
        }
      }, [r("span", [e._v(e._s(e.options.filterDrawerCloseText))])])];
    }, {
      toggleMobileDrawer: e.toggleMobileDrawer,
      mobileDrawerOpen: e.mobileDrawerOpen
    }), r("div", {
      staticClass: "search-filters__content"
    }, [r("div", {
      staticClass: "search-filters__form"
    }, [e._l(e.filters, function(s) {
      return [e._t("group", function() {
        return [r("Group", {
          attrs: {
            group: s,
            initiallyExpanded: e.options.filterInitiallyExpanded,
            setFilterValue: e.setFilterValue
          }
        }, [e._l(s.filters, function(i) {
          return [e._t("item", function() {
            return [r("Item", {
              attrs: {
                filter: i,
                setFilterValue: e.setFilterValue
              }
            })];
          }, {
            filter: i,
            setFilterValue: e.setFilterValue,
            extend: e.extend,
            extended: e.extended
          })];
        })], 2)];
      }, {
        group: s,
        initiallyExpanded: e.options.filterInitiallyExpanded,
        setFilterValue: e.setFilterValue,
        extend: e.extend,
        extended: e.extended
      })];
    }), e.options.filterAutoSubmit ? e._e() : e._t("submit", function() {
      return [r("button", {
        staticClass: "search-filters__btn",
        attrs: {
          disabled: e.filters.length ? !1 : "disabled",
          tabindex: e.filters.length ? !1 : "-1"
        },
        on: {
          click: function(s) {
            e.executeSearch(), e.toggleMobileDrawer(!1);
          }
        }
      }, [e._v(e._s(e.options.filterSubmitText))])];
    }, {
      toggleMobileDrawer: e.toggleMobileDrawer,
      executeSearch: e.executeSearch,
      filters: e.filters,
      filterSubmitText: e.options.filterSubmitText
    })], 2)])], 2)], 2)];
  }, {
    executeSearch: e.executeSearch,
    filters: e.filters,
    setFilterValue: e.setFilterValue,
    clearAllFilters: e.clearAllFilters,
    extend: e.extend,
    extended: e.extended
  })], 2);
}, Fe = [];
const qe = {
  name: "BlueFilters",
  components: { Group: $e, Item: Re },
  data() {
    return {
      mobileDrawerOpen: !1
    };
  },
  computed: {
    filters() {
      return this.$store.getters.filters.filter(
        (e) => e.visible ? !0 : e.filters.some((t) => t.selected)
      );
    },
    extended() {
      return this.$store.getters.extended;
    }
  },
  methods: {
    clearAllFilters() {
      this.$store.dispatch("removeAllTags");
    },
    toggleMobileDrawer(e = !this.mobileDrawerOpen) {
      this.mobileDrawerOpen = e;
    },
    setFilterValue(e, t, r) {
      let s;
      if (typeof t == "object" ? s = t.target.value : s = t, this.$store.commit("setFilterValue", { filter: e, value: s }), this.options.filterAutoSubmit)
        return this.executeSearch(r);
    },
    extend(e) {
      this.$store.commit("extend", e);
    },
    executeSearch(e) {
      return this.options.preserveResults && this.$store.commit("clearPreviousItemResults"), this.$store.dispatch("executeSearch", e);
    }
  }
}, S = {};
var Ie = /* @__PURE__ */ u(
  qe,
  Ee,
  Fe,
  !1,
  De,
  "ef2a9c4e",
  null,
  null
);
function De(e) {
  for (let t in S)
    this[t] = S[t];
}
const Ae = /* @__PURE__ */ function() {
  return Ie.exports;
}();
var Oe = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("button", {
    staticClass: "search__tag",
    on: {
      click: function(s) {
        return e.removeTag(e.tag);
      }
    }
  }, [e._v(e._s(e.tag.value))]);
}, Me = [];
const Ne = {
  name: "BlueTagItem",
  props: ["tag", "removeTag"]
}, P = {};
var je = /* @__PURE__ */ u(
  Ne,
  Oe,
  Me,
  !1,
  ke,
  "2bc590e2",
  null,
  null
);
function ke(e) {
  for (let t in P)
    this[t] = P[t];
}
const Ve = /* @__PURE__ */ function() {
  return je.exports;
}();
var Qe = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("span", {
    staticClass: "root"
  }, [e._t("default", function() {
    return [e.tags.length ? r("div", {
      staticClass: "search__tags"
    }, [e._l(e.tags, function(s) {
      return [e._t("item", function() {
        return [r("Item", {
          attrs: {
            tag: s,
            removeTag: e.removeTag
          }
        })];
      }, {
        tag: s,
        removeTag: e.removeTag
      })];
    })], 2) : e._e()];
  }, {
    tags: e.tags,
    removeTag: e.removeTag,
    clearAllTags: e.clearAllTags
  })], 2);
}, Le = [];
const Be = {
  name: "BlueTags",
  components: { Item: Ve },
  computed: {
    tags() {
      const e = (t) => {
        const r = [];
        return t.forEach((s) => {
          if (s.selected && r.push(s), s.filters) {
            let i = e(s.filters);
            i.length && r.push(...i);
          }
        }), r;
      };
      return this.$store.getters.results.filters.reduce((t, r) => {
        const s = e(r.filters);
        return t.push(...s), t;
      }, []);
    }
  },
  methods: {
    clearAllTags() {
      this.$store.dispatch("removeAllTags");
    },
    removeTag(e) {
      this.$store.dispatch("removeTagItem", e);
    }
  }
}, w = {};
var Ue = /* @__PURE__ */ u(
  Be,
  Qe,
  Le,
  !1,
  We,
  "74e8d732",
  null,
  null
);
function We(e) {
  for (let t in w)
    this[t] = w[t];
}
const ze = /* @__PURE__ */ function() {
  return Ue.exports;
}();
var Ke = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("div", {
    staticClass: "search-result"
  }, [e.result.image ? r("div", {
    staticClass: "search-result__img"
  }, [r("img", {
    attrs: {
      src: e.result.image
    }
  })]) : e._e(), r("div", {
    staticClass: "search-result__content"
  }, [r("h6", {
    staticClass: "search-result__title"
  }, [r("a", {
    attrs: {
      target: e.openInNewWindow ? "_blank" : !1,
      href: e.result.url
    }
  }, [e._v(e._s(e.result.title))])]), e.result.itemDate ? r("small", {
    staticClass: "search-result__date"
  }, [e._v(e._s(e.date))]) : e._e(), r("p", {
    staticClass: "search-result__summary"
  }, [e._v(e._s(e.result.summary))])])]);
}, He = [];
const Ge = {
  name: "BlueResultsItem",
  props: ["result", "formatDate", "openInNewWindow"],
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
    }
  }
}, T = {};
var Xe = /* @__PURE__ */ u(
  Ge,
  Ke,
  He,
  !1,
  Je,
  "2be2b012",
  null,
  null
);
function Je(e) {
  for (let t in T)
    this[t] = T[t];
}
const Ze = /* @__PURE__ */ function() {
  return Xe.exports;
}();
var Ye = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return r("span", {
    staticClass: "root"
  }, [e._t("default", function() {
    return [r("TransitionNavigate", [e.reloading ? e._t("loader", function() {
      return [r("SearchLoader")];
    }, {
      reloading: e.reloading
    }) : e.results.length ? r("div", {
      staticClass: "search__results"
    }, [e._l(e.results, function(s) {
      return e.results ? [e._t("item", function() {
        return [r("Item", {
          attrs: {
            result: s,
            openInNewWindow: e.options.openInNewWindow,
            formatDate: e.formatDate
          }
        })];
      }, {
        result: s,
        openInNewWindow: e.options.openInNewWindow,
        formatDate: e.formatDate
      })] : e._e();
    })], 2) : [e._t("empty", function() {
      return [r("p", {
        staticClass: "search__results-empty",
        domProps: {
          innerHTML: e._s(e.options.noResultsText)
        }
      })];
    }, {
      noResultsText: e.options.noResultsText
    })]], 2)];
  }, {
    results: e.results,
    reloading: e.reloading
  })], 2);
}, et = [];
const tt = {
  name: "BlueResults",
  components: { TransitionNavigate: F, SearchLoader: q, Item: Ze },
  props: [],
  data() {
    return {};
  },
  computed: {
    results() {
      return this.$store.getters.results.itemResults;
    },
    reloading() {
      return this.options.transitionOnReload ? this.$store.getters.reloading : !1;
    }
  },
  methods: {
    formatDate(e, t) {
      return O(new Date(e), t);
    },
    getElTop() {
      let e = this.$root.$el, t = 0;
      do
        t += e.offsetTop, e = e.offsetParent;
      while (e);
      return t = t < 0 ? 0 : t, t;
    },
    scrollToTop() {
      this.options.scrollOnReload && window.scrollTo({ top: this.getElTop(), behavior: "smooth" });
    }
  },
  watch: {
    reloading() {
      this.scrollToTop();
    }
  }
}, C = {};
var rt = /* @__PURE__ */ u(
  tt,
  Ye,
  et,
  !1,
  st,
  "18210f30",
  null,
  null
);
function st(e) {
  for (let t in C)
    this[t] = C[t];
}
const it = /* @__PURE__ */ function() {
  return rt.exports;
}();
var nt = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return e.isNumberVisible ? r(e.type, {
    tag: "component",
    staticClass: "search-pagination__number",
    on: {
      click: function(s) {
        return e.goToPage(e.index);
      }
    }
  }, [e._v(e._s(e.number))]) : e.isEllipseVisible ? r("span", {
    staticClass: "search-pagination__ellipsis"
  }) : e._e();
}, at = [];
const ot = {
  name: "BluePaginationItem",
  props: ["index", "number", "goToPage", "isActive", "isNumber", "isEllipsis"],
  computed: {
    type() {
      return this.isActive(this.index) ? "span" : "button";
    },
    isNumberVisible() {
      return this.isNumber(this.index);
    },
    isEllipseVisible() {
      return this.isEllipsis(this.index);
    }
  }
}, R = {};
var lt = /* @__PURE__ */ u(
  ot,
  nt,
  at,
  !1,
  ut,
  "03ce7297",
  null,
  null
);
function ut(e) {
  for (let t in R)
    this[t] = R[t];
}
const ct = /* @__PURE__ */ function() {
  return lt.exports;
}();
var dt = function() {
  var e = this, t = e.$createElement, r = e._self._c || t;
  return e.totalPages > 0 ? r("div", {
    ref: "root",
    staticClass: "search-pagination",
    class: {
      adjusting: e.isAdjusting
    }
  }, [e._t("default", function() {
    return [r("div", {
      ref: "container",
      staticClass: "search-pagination__inner"
    }, [e._t("previous", function() {
      return [r(e.enablePrev ? "button" : "span", {
        key: "prev",
        tag: "component",
        staticClass: "search-pagination__prev",
        attrs: {
          "aria-label": "Previous results page"
        },
        on: {
          click: function(s) {
            s.stopPropagation(), s.preventDefault(), e.enablePrev && e.navigate(-1);
          }
        }
      })];
    }, {
      enablePrev: e.enablePrev,
      navigate: e.navigate
    }), e._l(e.totalPages, function(s, i) {
      return [e._t("item", function() {
        return [r("Item", {
          attrs: {
            index: i,
            number: s,
            goToPage: e.goToPage,
            isActive: e.isActive,
            isNumber: e.isNumber,
            isEllipsis: e.isEllipsis
          }
        })];
      }, {
        number: s,
        index: i,
        goToPage: e.goToPage,
        isActive: e.isActive,
        isNumber: e.isNumber,
        isEllipsis: e.isEllipsis
      })];
    }), e._t("next", function() {
      return [r(e.enableNext ? "button" : "span", {
        key: "next",
        tag: "component",
        staticClass: "search-pagination__next",
        attrs: {
          "aria-label": "Next results page"
        },
        on: {
          click: function(s) {
            s.stopPropagation(), s.preventDefault(), e.enableNext && e.navigate(1);
          }
        }
      })];
    }, {
      enableNext: e.enableNext,
      navigate: e.navigate
    })], 2)];
  }, {
    totalPages: e.totalPages,
    currentPage: e.currentPage,
    enablePrev: e.enablePrev,
    enableNext: e.enableNext,
    navigate: e.navigate
  })], 2) : e._e();
}, ht = [];
const _t = {
  name: "BluePagination",
  components: { Item: ct },
  data() {
    return {
      hideCount: 0,
      adjusting: !1,
      debounceTimer: null
    };
  },
  computed: {
    reloading() {
      return this.$store.getters.reloading;
    },
    isAdjusting() {
      return !this.options.transitionOnReload && this.options.preserveResults ? !1 : this.adjusting;
    },
    totalPages() {
      return this.$store.getters.results.totalPages;
    },
    currentPage() {
      return this.$store.getters.currentPage;
    },
    enablePrev() {
      return this.currentPage > 0;
    },
    enableNext() {
      return this.currentPage < this.totalPages - 1;
    }
  },
  methods: {
    initializeHistory() {
      window.history.replaceState({ page: this.currentPage }, ""), window.onpopstate = (e) => {
        this.$store.dispatch("goToPage", e.state.page);
      };
    },
    goToPage(e) {
      this.options.paginationUsesHistory && window.history.pushState({ page: e }, ""), this.$store.dispatch("goToPage", e);
    },
    navigate(e) {
      this.goToPage(this.currentPage + e);
    },
    isActive(e) {
      return e === this.currentPage;
    },
    isNumber(e) {
      return this.getVisibilityAtIndex(e);
    },
    isEllipsis(e) {
      return this.getVisibilityAtIndex(e - 1);
    },
    async hideOverflow() {
      if (!this.$refs.root || !this.$refs.container) {
        this.adjusting = !1;
        return;
      }
      let e = this.$refs.root.offsetWidth, t = this.$refs.container.offsetWidth;
      for (; e < t && this.hideCount < this.totalPages - 5; )
        this.hideCount++, await this.$nextTick(), e = this.$refs.root.offsetWidth, t = this.$refs.container.offsetWidth;
      e:
        if (this.options.maxPaginationItems) {
          if (this.totalPages <= this.options.maxPaginationItems || this.totalPages - this.hideCount <= this.options.maxPaginationItems)
            break e;
          this.hideCount = this.totalPages - this.options.maxPaginationItems;
        }
      this.adjusting = !1;
    },
    getVisibilityAtIndex(e) {
      let t = !0;
      if (this.hideCount > 0) {
        const r = Math.floor(this.hideCount / 2);
        if (e == 0 || e == this.currentPage || e == this.totalPages - 1)
          return t;
        let s = Math.floor(this.totalPages / 2), i = s, n = s - r, a = s, o = s + r, l = 0;
        this.currentPage >= n - 2 && this.currentPage <= o + 2 && (s = this.currentPage, i = s - 2, n = i - r, a = s + 2, o = a + r), o > this.totalPages && (l = this.totalPages - o), n < 1 && (l = Math.abs(1 - n)), n = n + l, o = o + l, e <= i && e >= n && (t = !1), e >= a && e <= o && (t = !1);
      }
      return t;
    },
    async adjustAfterReload() {
      this.hideCount = 0, this.reloading && (this.adjusting = !0), await this.$nextTick(), this.reloading || this.hideOverflow();
    },
    adjustAfterResize() {
      clearTimeout(this.debounceTimer), this.adjusting = !0, this.debounceTimer = setTimeout(async () => {
        this.hideCount = 0, await this.$nextTick(), this.hideOverflow();
      }, 250);
    }
  },
  watch: {
    reloading() {
      this.adjustAfterReload();
    }
  },
  mounted() {
    this.options.paginationUsesHistory && this.initializeHistory(), this.hideOverflow(), window.addEventListener("resize", this.adjustAfterResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustAfterResize);
  }
}, E = {};
var ft = /* @__PURE__ */ u(
  _t,
  dt,
  ht,
  !1,
  pt,
  "cbcde08e",
  null,
  null
);
function pt(e) {
  for (let t in E)
    this[t] = E[t];
}
const gt = /* @__PURE__ */ function() {
  return ft.exports;
}(), xt = {
  install(e, t) {
    let r = Object.fromEntries(
      Object.entries(t).map(([i, n]) => (isNaN(n) ? n.toLowerCase() === "true" ? n = !0 : n.toLowerCase() === "false" && (n = !1) : n = Number(n), [i, n]))
    );
    r = A(r, {
      allowPreSearch: !1,
      filterAutoSubmit: !1,
      filterDrawerCloseText: "Close",
      filterDrawerToggleText: "Filter Results",
      filterParentsExcludeChildren: !1,
      filterInitiallyExpanded: "false",
      filterSubmitText: "Apply",
      hideRail: !1,
      maxPaginationItems: null,
      openInNewWindow: !0,
      pageLength: 10,
      paginationUsesHistory: !1,
      preserveResults: !1,
      queryAllowAutocomplete: null,
      queryPlaceholderText: "Search keyword or phrase",
      queryRequired: !1,
      queryStringKeyQuery: "query",
      queryStringKeyFilters: "filters",
      queryStringKeyPage: "page",
      querySubmitText: "Search",
      resetText: "Reset",
      resultsLabelTemplate: "Results {start} - {end} of {total}",
      scrollOnReload: !0,
      showFilters: !0,
      showFiltersCount: !0,
      showQuery: !0,
      showReset: !1,
      showSort: !0,
      showTags: !0,
      sortText: "Sort by",
      transitionOnReload: !0,
      noResultsText: "Sorry, there were no results found for your search. Please try again."
    }), e.mixin({
      data() {
        return {
          options: r
        };
      }
    }), e.component("SearchQuery", de), e.component("SearchFilters", Ae), e.component("SearchTags", ze), e.component("SearchResults", it), e.component("SearchPagination", gt), e.component("BlueSearch", re);
  }
};
export {
  xt as BlueSearch,
  yt as store
};
